<template>
    <tr class="workflows__list_table_item">
        <td class="workflows__list_table_item_name">{{ workflowName }}</td>
        <td class="workflows__list_table_item_target">{{ workflowTargetAudience }}</td>
        <td class="workflows__list_table_item_trigger">{{ workflowTrigger }}</td>
        <td class="workflows__list_table_item_after">{{ workflowInterval }}</td>
        <td class="workflows__list_table_item_enrolto">{{ workflowEnrolTo }}</td>
        <td class="workflows__list_table_item_status">
            <component-status :status="workflowStatus"></component-status>
        </td>
        <td class="workflows__list_table_item_actions">
            <div class="columns">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :name="'workflows-list-table-item-actions-edit'"
                        :theme="'default'"
                        :to="{ name: 'ebs-workflows-edit', params: { id: workflowId } }"
                    >Edit</component-button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>

import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentStatus from '@/components/default/shared/ComponentStatus'

export default {
  name: 'lms-superadmin-workflows-list-table-item',
  components: { ComponentStatus, ComponentButton },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    workflowName () {
      return this.item.workflow.name
    },
    workflowDescription () {
      return this.item.workflow.description
    },
    workflowId () {
      return this.item.workflow.id
    },
    workflowTargetAudience () {
      const targetAudience = this.item.resolvedIds.audience
      for (let target of Object.values(targetAudience)) {
        if (target !== null) {
          return target.map(obj => obj.name).join(', ')
        }
      }
    },
    workflowInterval () {
      const period = this.item.workflow.interval
      if (period !== 0 && period % 7 === 0) {
        return `${period / 7} week${period / 7 > 1 ? 's' : ''}`
      } else {
        return `${period} day${period === 0 || period > 1 ? 's' : ''}`
      }
    },
    workflowTrigger () {
      return this.item.resolvedIds.trigger.name
    },
    workflowEnrolTo () {
      return this.item.resolvedIds.enrolTo.map(obj => obj.name).join(', ')
    },
    workflowStatus () {
      return this.item.workflow.enabled ? 'active' : 'inactive'
    }
  },
  methods: {
    performArchiveWorkflows () {
      this.$store.dispatch('lmsSuperadminOrgUnitUpdateSuggestedCourses', { id: this.workflowId, suggestedCourses: [] }).then(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Auto-enrolment archive',
          message: 'Auto-enrolment has been successfully archived.',
          status: 'success'
        })
        this.$eventBus.$emit('get-workflows')
      }).catch(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Auto-enrolment archive',
          message: `Auto-enrolment hasn't been archived.`,
          status: 'error'
        })
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/workflows/_workflowslisttableitem.scss";
</style>
